// src/components/Projects.jsx
import React, { useRef } from 'react';
import { FaArrowRight } from 'react-icons/fa';

const projects = [
  {
    title: 'Hyperbolic Graph Retrieval',
    date: '2025 - 2026',
    link: 'https://github.com/nikhil-405/hyperbolic-graph-retrieval',
    paragraphs: [
      'Scalable graph retrieval using hyperbolic embeddings and a custom Transformer encoder (HypFormer).',
      'GAN‑style hashing enables fast Hamming search with hyperbolic re‑ranking for accuracy.',
    ],
  },

  {
    title: 'SafeDocs',
    date: '2026',
    link: 'https://github.com/nikhil-405/SafeDocs',
    paragraphs: [
      'Built an end-to-end document sharing service with fine grained access control.',
      'Scaled the service by sharding the database across remote shards.',
    ],
  },

  {
    title: 'AtomML',
    date: '2025',
    link: 'https://github.com/nikhil-405/atomml',
    paragraphs: [
      'Lightweight from‑scratch ML library built on NumPy/Pandas with clean, testable APIs.',
      'Implements core algorithms and simple neural nets without scikit‑learn/TensorFlow/PyTorch.',
    ],
  },

  {
    title: 'Lottery Ticket Hypothesis',
    date: '2025',
    link: 'https://github.com/aditya-me13/lottery_ticket_hypothesis',
    paragraphs: [
      'Iterative magnitude pruning to discover sparse “winning tickets” that retrain near dense baselines.',
      'Reduced number of parameters by >50% while maintaining similar accuracy scores across MNIST/Fashion/CIFAR‑10.',
    ],
  },

];

export default function Projects() {
  const containerRef = useRef(null);

  return (
    <>
      <div className="projects-container">
        <div className="cards-wrapper" ref={containerRef}>
          <div className="scroll-spacer" />
          {projects.map((proj) => (
            <a
              href={proj.link}
              target="_blank"
              rel="noopener noreferrer"
              className="card-link"
              key={proj.title}
            >
              <div className="card card-with-arrow">
                <FaArrowRight className="project-card-arrow" />
                <h3>{proj.title}</h3>
                <p><em>{proj.date}</em></p>
                {proj.paragraphs.map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>
            </a>
          ))}
          
          <div className="scroll-spacer" />
        </div>
      </div>
    </>
  );
}
